import { Component, ElementRef } from '@angular/core';
import * as moment from 'moment';
import { PageBase } from 't4core';

@Component({
  selector: 'used-parts-per-trailer-report',
  templateUrl: './UsedPartsPerTrailerReport.html',
  styleUrls: ['./UsedPartsPerTrailerReport.css']
})
export class UsedPartsPerTrailerReportComponent extends PageBase {
  private _fromDate: moment.Moment = moment().startOf('month');
  private _toDate: moment.Moment = moment().endOf('month');

  public reportRows: any[] = [];
  public isLoading: boolean = false;

  public get fromDate(): moment.Moment { return this._fromDate; }
  public set fromDate(value: moment.Moment) { this._fromDate = value; }

  public get toDate(): moment.Moment { return this._toDate; }
  public set toDate(value: moment.Moment) { this._toDate = value; }

  constructor(el: ElementRef) {
    super(el, 'UsedPartsPerTrailerReport');
  }

  public async ngOnInit() {
    await this.loadData();
  }

  public async loadData() {
    this.isLoading = true;

    try {
      this.reportRows = await this.Api.get<any[]>('Data/GetReport', {
        reportName: 'UsedPartsPerTrailerReport',
        from: this.fromDate,
        to: this.toDate
      });

      this.fromDate = this.fromDate.clone();
      this.toDate = this.toDate.clone();
    }
    finally {
      this.isLoading = false;
    }
  }
}
